import React, {useState} from 'react'
import styled from '@emotion/styled'

import {BottomSheet} from '@vio/atlas/BottomSheet'
import {Button} from '@vio/atlas/Button'
import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

import {useIsSaveFraming} from '../../hooks/useIsSaveFraming'
import {myListMessages} from '../../myListMessages'

const SheetBody = styled.span`
  .--inline-icon {
    display: inline;
    vertical-align: sub;
  }
`

export const MobileIcon = () => {
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false)
  const saveFramingIsOn = useIsSaveFraming()

  const handleOnOpen = () => {
    setIsBottomSheetOpen(true)
  }

  return (
    <>
      <span
        role="button"
        tabIndex={0}
        onKeyDown={() => handleOnOpen()}
        onClick={() => handleOnOpen()}
      >
        <Icon
          name="Information"
          size="sm"
          colorPath="content.neutral.secondary"
        />
      </span>

      <BottomSheet
        isOpen={isBottomSheetOpen}
        onClose={() => setIsBottomSheetOpen(false)}
        navBarProps={{
          centerContent: saveFramingIsOn ? (
            <FormattedMessageWrapper {...myListMessages.tabLabel} />
          ) : (
            <FormattedMessageWrapper
              id="priceAlerts"
              defaultMessage="Price alerts"
            />
          )
        }}
      >
        <Box paddingTop="s500" paddingBottom="s300">
          <Text variant="titleL">
            {saveFramingIsOn ? (
              <FormattedMessageWrapper {...myListMessages.onboardingTitle} />
            ) : (
              <FormattedMessageWrapper
                id="priceWatchTitle"
                defaultMessage="Never miss a price drop"
              />
            )}
          </Text>
        </Box>
        <Box paddingBottom="s500">
          <Text variant="bodyM">
            {saveFramingIsOn ? (
              <SheetBody>
                <FormattedMessageWrapper
                  {...myListMessages.saveStayDescription}
                  values={{
                    icon: (
                      <Icon className="--inline-icon" name="Heart" size="sm" />
                    )
                  }}
                />
              </SheetBody>
            ) : (
              <FormattedMessageWrapper
                id="priceAlertOnboardingDescription"
                defaultMessage="We actively monitor prices in the background and will notify you when the prices change."
              />
            )}
          </Text>
        </Box>

        <Box paddingTop="s400" paddingBottom="s400">
          <Button
            variant="tertiary"
            fullWidth
            onClick={() => setIsBottomSheetOpen(false)}
          >
            <FormattedMessageWrapper
              id="priceAlertOnboardingConfirmation"
              defaultMessage="Got it"
            />
          </Button>
        </Box>
      </BottomSheet>
    </>
  )
}
